import {
	pick,
} from 'lodash';

import {
	createBlock,
	createBlocksFromInnerBlocksTemplate,
} from '@wordpress/blocks';

import { defaultBackground } from '../../components/reusable/background/attributes';

export default {
	from: [
			{
				type: 'block',
				blocks: [ 'core/gallery' ],
				transform: ( attributes ) => {
					const { images, imageCrop } = attributes;

					const slidesToShow = imageCrop ? 1 : 0;

					const gutensliderAttributes = {
						contentMode: 'change',
						animation: 'slide',
						slidesToShow,
						slidesToShowMd: slidesToShow,
						slidesToShowSm: slidesToShow,
					};
					const innerSlides = images.map( ( image ) => {
						const { alt, url, id, type } = image;
						return {
							name: 'eedee/block-gutenslide',
							attributes: {
								contentPosition: 'center',
								background: {
									...defaultBackground,
									backgroundType: 'image',
									backgroundImage: {
										url,
										id,
										alt,
										type: 'image',
									},
								},
							},
						};
					});

					return createBlock(
						'eedee/block-gutenslider',
						gutensliderAttributes,
						createBlocksFromInnerBlocksTemplate( innerSlides ),
					);
				}
			},
			{
				type: 'block',
				blocks: [ 'core/cover' ],
				transform: ( attributes, innerBlocks ) => {
					const {
						id,
						url,
						align,
						minHeight,
						minHeightUnit,
						focalPoint,
						backgroundType,
						hasParallax,
						//todo dimRatio,
					} = attributes;

					const sliderHeight = `${ minHeight ? minHeight : 50 }${ minHeightUnit ? minHeightUnit : 'vh' }`;

					const gutensliderAttributes = {
						contentMode: 'fixed',
						align,
						animation: 'fade',
						sliderHeight,
						sliderHeightMd: sliderHeight,
						sliderHeightSm: sliderHeight,
						hasParallax,
					};

					const slide = {
						name: 'eedee/block-gutenslide',
						attributes: {
							contentPosition: 'center',
							background: {
								...defaultBackground,
								backgroundType,
								backgroundFocalPoint: focalPoint,
								backgroundVideoFocalPoint: focalPoint,
								backgroundImage: backgroundType === 'image' ? {
									url,
									id,
									type: 'image',
								} : {},
								backgroundVideo: backgroundType === 'video' ? {
									url,
									id,
									type: 'video',
								} : {}
							},
						},
					};

					const mergedInnerBlocks = [ slide, ...innerBlocks ];

					return createBlock(
						'eedee/block-gutenslider',
						gutensliderAttributes,
						createBlocksFromInnerBlocksTemplate( mergedInnerBlocks ),
					);
				},
		},
	],
	to: [
		{
			type: 'block',
			blocks: [ 'core/gallery' ],
			transform: ( attributes, innerBlocks ) => {
				const { slidesToShow } = attributes;

				const images = innerBlocks.filter( ib => {
					return ib.attributes.background && ib.attributes.background.backgroundType === 'image';
				}).map( ( ib ) => {
					const { url, alt, id } = ib.attributes.background.backgroundImage;
					return {
						url,
						alt,
						id,
					};
				});

				const galleryAttributes = {
					imageCrop: slidesToShow === 1 ? true : false,
					images
				};

				return createBlock(
					'core/gallery',
					galleryAttributes
				);
			}
		},
	]
};
